import upperFirst from 'lodash/upperFirst';
import toNumber from 'lodash/toNumber';
import { AutomatedBreakType } from '@sdk/settings/types';

export const getFieldName = (automatedBreakType: AutomatedBreakType, fieldName: string) =>
  `automatedBreaks${upperFirst(automatedBreakType)}${upperFirst(fieldName)}`;

export const getSafeNumber = (value: string): number => {
  const numberValue = toNumber(value);

  return Number.isNaN(numberValue) ? 0 : numberValue;
};
